module.exports = __webpack_public_path__ + "static/group-41@3x-8ba49ab5e31e947f122e27168370471a.png";